// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"Y7gTbtwhpbnqRAP982tY"};